import Button from '@/components/Button';
import Container from '@/components/Container';
import SubContainer from '@/components/Container/SubContainer';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Tooltip from '@/components/Tooltip';
import { AdminTabs } from '../components/tabs';
import ExcelUploader from '../components/spreadsheet';
import { UserPreviewDialog } from '../components/UserPreviewDialog';
import { useSchoolManagement } from '../hooks/useSchoolManagement';
import SchoolsFilter from '@/components/SchoolsFilter';

export const SchoolManagement = () => {
  const {
    page,
    forename,
    school,
    tooltipVisible,
    loadingInvite,
    loadingImport,
    loadingPDF,
    loadingSendInvitation,
    usersPreview,
    isPreviewDialogOpen,
    template,
    schoolId,
    user,
    setSchoolId,
    setTemplate,
    setIsPreviewDialogOpen,
    setTooltipVisible,
    onShowInvitationPreview,
    onSendInvitationEmail,
    onImportStaff,
    downloadQRCodePDF,
  } = useSchoolManagement();

  return (
    <Container>
      <SubContainer className="mt-sh-60 flex flex-col items-start justify-start px-4 lg:col-start-3 lg:col-end-11">
        <AdminTabs />
        <div className="relative mt-sh-30 flex w-full flex-col items-start justify-start gap-sh-15">
          {user?.ws_permission?.isMAT && (
            <div className="flex w-full flex-col items-start justify-start gap-sh-15">
              <h1 className=" text-sh-md font-bold">School</h1>
              <SchoolsFilter
                selectedSchoolsIds={[schoolId || '']}
                onChange={(selectedIds) => setSchoolId(selectedIds[0])}
                showChips
                className="w-full"
                onlyOne
                asRegularUser={true}
              />
            </div>
          )}

          <h1 className=" text-sh-md font-bold">
            {page?.schoolManagement.welcomeTitle} {' ' + forename}
          </h1>
          <p className="  text-sh-xs">{page?.schoolManagement.welcomeDescription}</p>

          <p className=" my-5 rounded-2xl bg-[#EBF2FC] px-3 py-5 text-sh-md">
            {page?.schoolManagement.yourAccessCode} <strong>{school?.code}</strong>
          </p>

          <Button
            onClick={() => {
              navigator.clipboard.writeText(school?.code);
              setTooltipVisible(true);
              setTimeout(() => setTooltipVisible(false), 2000);
            }}>
            {page?.schoolManagement.btnCopyCodeTxt}
          </Button>
          <Tooltip visible={tooltipVisible} message={page?.schoolManagement?.tooltipCopiedMessage || ''} />
        </div>

        <div className="mt-sh-30 flex w-full flex-col items-start justify-start gap-sh-15">
          <h1 className=" text-sh-md font-bold">{page?.schoolManagement.shareCodeTitle}</h1>
          <p className=" text-sh-xs">{page?.schoolManagement.sendEmailSubTitle}</p>
          <div className="flex items-center justify-start">
            <div className="border-primary-500 pr-4">
              <Button loading={loadingInvite} onClick={() => onShowInvitationPreview()}>
                {page?.schoolManagement.btnInviteStaffTxt}
              </Button>
            </div>
            <div className="border-primary-500 pr-4">
              <Button loading={loadingImport} onClick={() => onImportStaff()}>
                {page?.schoolManagement.btnImportStaffWondeTxt}
              </Button>
            </div>

            <p className="text-sh-xs">{page?.schoolManagement.orText}</p>
            <ExcelUploader onImportStaff={onImportStaff} />
          </div>
        </div>

        <div className="mt-sh-30 flex w-full flex-col items-start justify-start gap-sh-15">
          <h1 className=" text-sh-md font-bold">{page?.schoolManagement.downloadQrCode}</h1>
          <p className=" text-sh-xs">{page?.schoolManagement.downloadQrCodeDescription}</p>
          <Button
            loading={loadingPDF}
            onClick={() => {
              downloadQRCodePDF();
            }}>
            {page?.schoolManagement.btnDownloadPdf}
          </Button>
        </div>

        <div className="mt-sh-30 flex w-full flex-col items-start justify-start gap-sh-15">
          <h1 className=" text-sh-md font-bold">{page?.schoolManagement.copyPasteTitle}</h1>
          <p className=" text-sh-xs">{page?.schoolManagement.copyTxtSubTItle}</p>
          <ReactQuill theme="snow" value={template} onChange={setTemplate} />
        </div>

        <UserPreviewDialog
          isOpen={isPreviewDialogOpen}
          onClose={() => setIsPreviewDialogOpen(false)}
          users={usersPreview}
          onConfirm={onSendInvitationEmail}
          loading={loadingSendInvitation}
        />
      </SubContainer>
    </Container>
  );
};
